<template>
	<el-dialog title="系统提示" :visible.sync="dialogVisible" width="450px" class="toolTipProp" :close-on-click-modal="false">
		<div>
			<div class="textC">
				<i class="iconfont icontishichuang3 tanchuang-icon" style="color:#72c7ff"></i>
				<!-- <img src="../../assets/img/tanchuang/icon-4.png" alt="" class="imgsize"> -->
			</div>
			<div class="texts textC">{{ tips2 }}</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="addbtn" class="addbtn btn-icon-flex">
				<i class="iconfont iconqueding btn-icon"></i>
				<!-- <img src="../../assets/img/login/xiayibu.png" alt=""> -->
				<span>确 定</span>
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'ToolTipProp2',
	props: {
		tips: {
			type: String,
			default: '请选择要编辑的数据!'
		}
	},
	data() {
		return {
			dialogVisible: false,
			tips2: ''
		};
	},
	methods: {
		addbtn() {
			this.dialogVisible = false;
		},
		show(str) {
			this.tips2 = str;
			this.dialogVisible = true;
		}
	}
};
</script>

<style lang="less">
.toolTipProp {
	.el-dialog .el-dialog__body {
		padding-top: 33px;
		padding-bottom: 44px;
	}

	.el-dialog .el-dialog__footer {
		padding-top: 0px;
		padding-bottom: 39px;
	}

	.texts {
		margin-top: 12px;
		font-family: MicrosoftYaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #666666;
	}

	.addbtn {
		width: 140px;
		height: 40px;
		background-color: #0092f1;
		border-radius: 3px;
		padding: 0px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 12px 42px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			// align-content:space-around;
			justify-content: center;
		}
	}

	.imgsize {
		width: 68px;
		// height: 68px;
	}
}
</style>
